import { StringToDate } from "./DateHelpers";
import {
  MAX_DIRECT_EXPORT_ROWS,
  CountDirectExportDetailRows,
} from "./ExportRowCountHelpers";

// Largest number of detail rows the View Report grid will attempt to render in the browser.
// Above this the page can become unresponsive, so the user is asked to narrow the request instead.
export const MAX_DETAILS_GRID_ROWS = MAX_DIRECT_EXPORT_ROWS;

const DETAIL_DATE_COLUMNS = ["checkDate", "fillDate", "transactionDate"];

// Flattens the grouped GetDetails result ([{ summary, details: [...] }]) into grid rows.
// When the row count exceeds maxRows the (expensive) date conversion and de-duplication are skipped
// and { rows: [], exceedsLimit: true } is returned.
export function BuildFeeAndAdjustmentDetailRows(
  groupedData,
  maxRows = MAX_DETAILS_GRID_ROWS
) {
  if (CountDirectExportDetailRows(groupedData) > maxRows) {
    return { rows: [], exceedsLimit: true };
  }

  const rows = [];
  const seen = new Set();

  (groupedData || []).forEach((item) => {
    ((item && item.details) || []).forEach((detail) => {
      let row = detail;
      DETAIL_DATE_COLUMNS.forEach((column) => {
        if (row[column]) row = { ...row, [column]: StringToDate(row[column]) };
      });

      // A row whose checkDate was converted to a Date is never treated as a duplicate (Date
      // instances are compared by reference), which is how the previous findIndex-based
      // de-duplication behaved; only rows without a check date are de-duplicated.
      if (row.checkDate instanceof Date) {
        rows.push(row);
        return;
      }

      const key = JSON.stringify([
        row.checkNumber,
        row.payer,
        row.checkAmount,
        typeof row.checkDate,
        row.checkDate,
      ]);

      if (seen.has(key)) return;
      seen.add(key);
      rows.push(row);
    });
  });

  return { rows, exceedsLimit: false };
}

// Sums feeAdjustmentAmount per payer, ordered by payer name.
export function GetAdjustmentsByPayer(rows) {
  const totalsByPayer = new Map();

  (rows || []).forEach((row) => {
    const existing = totalsByPayer.get(row.payer);
    if (existing) {
      existing.totalFeeAdjustmentAmountPerPayer += row.feeAdjustmentAmount;
    } else {
      totalsByPayer.set(row.payer, {
        payer: row.payer,
        totalFeeAdjustmentAmountPerPayer: row.feeAdjustmentAmount,
      });
    }
  });

  return Array.from(totalsByPayer.values()).sort((a, b) => {
    if (a.payer < b.payer) return -1;
    if (a.payer > b.payer) return 1;
    return 0;
  });
}
